import { render, staticRenderFns } from "./RideitInvitations.vue?vue&type=template&id=a4d20226&scoped=true"
import script from "./RideitInvitations.vue?vue&type=script&lang=ts"
export * from "./RideitInvitations.vue?vue&type=script&lang=ts"
import style0 from "./RideitInvitations.vue?vue&type=style&index=0&id=a4d20226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d20226",
  null
  
)

export default component.exports